import 'reflect-metadata';
import './infrastructure/di/setup';
import './index.scss';

import { translator } from '@descomplica/microfrontend-react';
import ReactDOM from 'react-dom';

import { microfrontendConfig } from './infrastructure/config/microfrontend.config';
import Microfrontend from './presentation/Microfrontend';
import reportWebVitals from './reportWebVitals';
import { setupPocket } from './setupPocket';
import i18nextInit from './translations/i18n';

i18nextInit();
setupPocket();

if (!microfrontendConfig.isMicrofrontend()) {
  ReactDOM.render(<Microfrontend />, microfrontendConfig.getRootElement());
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

export default translator.exposeMicrofrontend(Microfrontend);
